import CreatorNewPaymentMethodPage from "./CreatorNewPaymentMethodPage";

export default CreatorNewPaymentMethodPage;
